import { EventEmitter } from '@angular/core';
import { Component, Input, Output } from '@angular/core';

@Component({
  selector: 'ff-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss']
})
export class SliderComponent {

  /**
   * Allow the user to disable the component
   * Default value: false;
   * @internal
   */
  @Input() disabled: boolean = false;

  /**
   * Allow the user to invert the component
   * Default value: false;
   * @internal
   */
  @Input() invert: boolean = false;

  /**
   * Max value in the slider
   * Default value: 100;
   * @internal
   */
  @Input() max: number = 100;

  /**
   * Max value in the slider
   * Default value: 0;
   * @internal
   */
  @Input() min: number = 0;

  /**
   * Allow the user to show ticks in the component
   * Default value: false;
   * @internal
   */
  @Input() showTicks: boolean = false;

  /**
   * The values at which the thumb will snap.
   * Default value: 0;
   * @internal
   */
  @Input() step: number = 1;

  /**
   * Whether or not to show the thumb label.
   * Default value: false;
   * @internal
   */
  @Input() thumbLabel: boolean = false;

    /**
   * Value of the slider.
   * Default value: 0;
   * @internal
   */
  @Input() value: number = 0;

  /**
   * Return the updated value.
   * @internal
   */
  @Output() newValue = new EventEmitter<number>();

  constructor() {  }

  setNewValue = (): void => {
    this.newValue.emit(this.value);
  }

}
